import { render, staticRenderFns } from "./FaqItemList.vue?vue&type=template&id=4f0f5ff2&scoped=true&"
import script from "./FaqItemList.vue?vue&type=script&lang=js&"
export * from "./FaqItemList.vue?vue&type=script&lang=js&"
import style0 from "./FaqItemList.vue?vue&type=style&index=0&id=4f0f5ff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f5ff2",
  null
  
)

export default component.exports